import { createAsyncActionType } from './index';

export const COURSE_DETAILS_GET = createAsyncActionType(
  'coursedetails',
  'COURSE_DETAILS_GET'
);
export const COURSE_NOTIFICATION_SET = createAsyncActionType(
  'coursedetails',
  'COURSE_NOTIFICATION_SET'
);
export const ACTIVITY_SET_LIKEDISLIKE = createAsyncActionType(
  'coursedetails',
  'ACTIVITY_SET_LIKEDISLIKE'
);
export const COURSE_SET_COMMENT = createAsyncActionType(
  'coursedetails',
  'COURSE_SET_COMMENT'
);
export const COURSE_SET_COMMENT_REPLY = createAsyncActionType(
  'coursedetails',
  'COURSE_SET_COMMENT_REPLY'
);
export const COMMENT_VISIBILITY_SET = createAsyncActionType(
  'coursedetails',
  'COMMENT_VISIBILITY_SET'
);
export const COURSE_GET_COMMENTS = createAsyncActionType(
  'coursedetails',
  'COURSE_GET_COMMENTS'
);
export const QUIZ_SEND_ANSWERS = createAsyncActionType(
  'coursedetails',
  'QUIZ_SEND_ANSWERS'
);

export const EVENT_QUIZ_SEND_ANSWERS = createAsyncActionType(
  'coursedetails',
  'EVENT_QUIZ_SEND_ANSWERS'
);
export const EVENT_QUIZ_START = createAsyncActionType(
  'coursedetails',
  'EVENT_QUIZ_START'
);

export const SURVEY_QUESTIONS_GET = createAsyncActionType(
  'coursedetails',
  'SURVEY_QUESTIONS_GET'
);

export const SURVEY_SEND_ANSWERS = createAsyncActionType(
  'coursedetails',
  'SURVEY_SEND_ANSWERS'
);

export const COURSE_RECOMMEND = createAsyncActionType(
  'coursedetails',
  'COURSE_RECOMMEND'
);

export const COURSE_LEAVE = createAsyncActionType(
  'coursedetails',
  'COURSE_LEAVE'
);

export const QUIZ_START_TRACKING = createAsyncActionType(
  'coursedetails',
  'QUIZ_START_TRACKING'
);

export const COURSE_DETAILS_RESET = '@@coursedetails/COURSE_DETAILS_RESET';
export const QUIZ_RESET = '@@coursedetails/QUIZ_RESET';
export const SURVEY_RESET = '@@coursedetails/SURVEY_RESET';
